import { IconButton, ListItem, ListItemText, Typography } from "@mui/material"
import ClearIcon from "@mui/icons-material/Clear";
import SquareIcon from "@mui/icons-material/Square";

const HashtagItemComponent: React.FC<{ removeHashtagFunc, hashtag }> = ({ removeHashtagFunc, hashtag }) => {
    return (
        <ListItem
              disableGutters
              secondaryAction={
                <IconButton
                  aria-label="delete"
                  sx={{ color: "#ffffff" }}
                  onClick={removeHashtagFunc}
                >
                  <ClearIcon />
                </IconButton>
              }
              sx={{
                border: "1px solid rgb(213, 218, 215)",
                borderRadius: "5px",
                marginBottom: "20px",
              }}
            >
              <ListItemText
                primary={
                  <Typography>
                    <IconButton
                      aria-label="delete"
                      sx={
                        hashtag.intitlecontent
                          ? { color: "#4BB543" }
                          : { color: "#B00020" }
                      }
                    >
                      <SquareIcon />
                    </IconButton>{" "}
                    {hashtag.hashtag}
                  </Typography>
                }
                sx={{
                  marginLeft: "10px",
                  color: "#fffffff",
                }}
              />
            </ListItem>
    )
}

export default HashtagItemComponent
